const APP_BASE_URL = "https://wagesbackend.elcexercises.org"

// const APP_BASE_URL = "http://localhost:8892";
export default APP_BASE_URL;
